import {Component, OnInit} from '@angular/core';
import {FixedPriceService} from "../../services/fixedPrice/fixed-price.service";
import { Router } from '@angular/router';
import { DecimalPipe } from 'src/app/shared/decimal.pipe';
import { SeaModel } from 'src/app/models/sea/sea-model';
import { MinDTO } from 'src/app/models/min-dto';
import { AirModel } from 'src/app/models/air/air-model';
import { ContainerTypeService } from 'src/app/services/container-type/container-type.service';
import { onSelectFixedPrice } from '../dashboard-fixed-prices/dashboard-fixed-prices.component';
import { onSelectFixedPriceAir } from '../dashboard-fixed-prices/dashboard-fixed-prices.component';
import { ClickHistorySubject } from 'src/app/events/click-history.events';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';

@Component({
  selector: 'app-dashboard-discount-segment',
  templateUrl: './dashboard-discount-segment.component.html',
  styleUrls: ['./dashboard-discount-segment.component.scss']
})



export class DashboardDiscountSegmentComponent implements OnInit{
    discount: any;
    loading: boolean = true;
    cwValue = 166.666667;
    containerTypes: MinDTO[] = [];
    constructor(private fixedPriceService: FixedPriceService, private router: Router, private decimalPipe: DecimalPipe,  private seaContainerTypeService: ContainerTypeService) {
    }
    async ngOnInit() {
      this.loading = true;
      try {
        this.discount = await this.fixedPriceService.getDiscountSegment().toPromise();
        this.loading = false;
      } catch {
        this.loading = false;
      }

      this.containerTypes = await this.seaContainerTypeService.containers().toPromise();

    }

      onSearch(data: any) {    

          const historyModel = new SearchLogClickHistoryModel();
          historyModel.productName = 'main-discount'
          historyModel.info = data.segmentName;
          let operationType = 'AIR';
          if(data.operationType == 'SEA') {
            operationType = data.partialFull == 'F' ? 'FCL': 'LCL';
          } 
          historyModel.costType = operationType;
          
          ClickHistorySubject.next(historyModel);

        let model: any = null;
          if(data.operationType == 'SEA') {
    
            model = new SeaModel();
            model.readinessDate = new Date(); 
            model.departureCountry =  data.departureCountry;
            model.arrivalCountry =  data.arrivalCountry;
            model.containerType = data.seaContainerType;
            model.pieces  = 1;
            model.containerCount = 1; 
            model.tonnage =  12000; 
            model.isOnlinePrice = true;
            model.service = 'ATA';
            model.commodity = 'GENERALCARGO'; 
            model.goodPrice = 1500; 
            model.incoterm = 'FOB'; 
            model.departureCountry = data.fromCountry;
            model.arrivalCountry = data.toCountry;
             model.td = 'T'; 
             
            if(data.partialFull == 'F') {
              model.operationType = 'FCL'; 
              model.kp = 'F'
              model.containerType = this.containerTypes.find(f => f.name == '40 DC')

            } else {
              model.operationType = 'LCL'; 
              model.kp = 'P'
              model.totalWeight = 1000;
              model.totalVolume = 1;
              model.packingType = "CARTONS";

            }
           
            model.stackable = true; 
           
            model.departurePort = data.fromPort;
            model.arrivalPort = data.toPort;
           
            
             
            onSelectFixedPrice.next(model);
          }
          if(data.operationType == 'AIR') {
            model = new AirModel();
            model.readinessDate = new Date(); 
            model.departureCountry =  data.departureCountry;
            model.arrivalCountry =  data.arrivalCountry;
            model.pieces  = 1;
            model.isOnlinePrice = true;
            model.service = 'ATA';
            model.commodity = 'GCR'; 
            model.goodPrice = 1500; 
            model.incoterm = 'FOB'; 
            model.stackable = true; 
            model.td = 'T'; 
            model.totalVolume = 1
            model.totalWeight = 170
            model.packingType = 'CARTONS'
            model.departurePort = data.fromPort;
            model.arrivalPort = data.toPort;
            model.departureCountry = data.fromCountry;
            model.arrivalCountry = data.toCountry;
            const calculatedCwg = (Number(String(model.totalVolume).replace(',', '.')) * this.cwValue);
            model.cwg =  Number(Number(this.decimalPipe.transform(calculatedCwg > model.totalWeight ? calculatedCwg : model.totalWeight)).toFixed())
            onSelectFixedPriceAir.next(model);  
          }
    
          
          this.router.navigate([`/home/${data.operationType == 'SEA' ? 'sea' : 'air'}`]);
        }
}
